//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ApiClientConfig {
  public defaultHeaders: { [key: string]: any } = {};
}

export class BaseApiClient {
  private apiClientConfig: ApiClientConfig;

  constructor(apiClientConfig: ApiClientConfig) {
    this.apiClientConfig = apiClientConfig;
  }

  protected getBaseUrl(_: string, baseUrl = urlReplacer): string {
    return baseUrl;
  }

  protected transformOptions(requestConfig: RequestInit): Promise<RequestInit> {
    requestConfig.credentials = "include";

    if (requestConfig.headers == null)
      requestConfig.headers = new Headers();

    for (const headerKey in this.apiClientConfig.defaultHeaders) {
      Reflect.set(
        requestConfig.headers,
        headerKey,
        this.apiClientConfig.defaultHeaders[headerKey]
      );
    }

    return Promise.resolve(requestConfig);
  }

  protected parseJsonObject(response: string) {
    try {
      // @ts-ignore
      const jsonObject = JSON.parse(response, this.jsonParseReviver);
      if (typeof jsonObject !== "object")
        return undefined;

      return jsonObject;
    }
    catch {
      return undefined;
    }
  }

  protected async transformResult<T>(
    //@ts-ignore
    url: string,
    response: Response,
    processFn: (r: Response) => Promise<T>
  ): Promise<T> {
    return processFn(response)
      .catch(ex => {
        if (ex != null &&
          // @ts-ignore
          ApiException.isApiException(ex)
        ) {
          if (ex.status === 403) {
            const http403Message = 'HTTP 403. Access denied';
            ex.message = http403Message;
            ex.result = {
              ErrorCode: ex.status,
              ErrorMessage: http403Message,
              Parameters: {
                'url': response.url
              }
            };
          }
          else if (ex.response != null && ex.response.length > 0) {
            if (ex.status === 204) {
              return null as unknown as T;
            }
            const responseAsJson = this.parseJsonObject(ex.response);
            ex.result = responseAsJson;

            if (responseAsJson != null && responseAsJson.ErrorMessage != null) {
              ex.message = responseAsJson.ErrorMessage;
            }
          }
        }

        throw ex;
      });
  }
}

export class Client extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return OK
     */
    config(quoteId: string): Promise<AnonymousQuoteInfo> {
        let url_ = this.baseUrl + "/po-upload/config/{quoteId}";
        if (quoteId === undefined || quoteId === null)
            throw new Error("The parameter 'quoteId' must be defined.");
        url_ = url_.replace("{quoteId}", encodeURIComponent("" + quoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processConfig(_response));
        });
    }

    protected processConfig(response: Response): Promise<AnonymousQuoteInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnonymousQuoteInfo;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnonymousQuoteInfo>(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    upload(quoteId: string, file: FileParameter | undefined): Promise<AnonymousUploadResult> {
        let url_ = this.baseUrl + "/po-upload/upload/{quoteId}";
        if (quoteId === undefined || quoteId === null)
            throw new Error("The parameter 'quoteId' must be defined.");
        url_ = url_.replace("{quoteId}", encodeURIComponent("" + quoteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpload(_response));
        });
    }

    protected processUpload(response: Response): Promise<AnonymousUploadResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnonymousUploadResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnonymousUploadResult>(null as any);
    }

    /**
     * @param returnUrl (optional) 
     * @return OK
     */
    signIn(returnUrl: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Auth/SignIn?";
        if (returnUrl === null)
            throw new Error("The parameter 'returnUrl' cannot be null.");
        else if (returnUrl !== undefined)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSignIn(_response));
        });
    }

    protected processSignIn(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postEvent(workspaceId: string, body: EventLoggerRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/eventlogger/PostEvent";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPostEvent(_response));
        });
    }

    protected processPostEvent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getExtensions(workspaceId: string): Promise<ExtensionTile[]> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/extensions/GetExtensions";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetExtensions(_response));
        });
    }

    protected processGetExtensions(response: Response): Promise<ExtensionTile[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtensionTile[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExtensionTile[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllInvoicesForCustomer(workspaceId: string): Promise<GetInvoicesResponse> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/invoices/GetAllInvoicesForCustomer";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllInvoicesForCustomer(_response));
        });
    }

    protected processGetAllInvoicesForCustomer(response: Response): Promise<GetInvoicesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetInvoicesResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetInvoicesResponse>(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @return OK
     */
    downloadInvoice(workspaceId: string, invoiceId: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/invoices/DownloadInvoice?";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadInvoice(_response));
        });
    }

    protected processDownloadInvoice(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    getSeatReservedAssignments(workspaceId: string): Promise<ReservedSeatAssignment[]> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/licensemanagement/GetSeatReservedAssignments";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSeatReservedAssignments(_response));
        });
    }

    protected processGetSeatReservedAssignments(response: Response): Promise<ReservedSeatAssignment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReservedSeatAssignment[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReservedSeatAssignment[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createSeatReservedAssignment(workspaceId: string, body: CreateReservedSeatAssignmentRequest | undefined): Promise<ReservedSeatAssignment> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/licensemanagement/CreateSeatReservedAssignment";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateSeatReservedAssignment(_response));
        });
    }

    protected processCreateSeatReservedAssignment(response: Response): Promise<ReservedSeatAssignment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReservedSeatAssignment;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReservedSeatAssignment>(null as any);
    }

    /**
     * @param licenseAssignmentId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    removeSeatReservedAssignment(licenseAssignmentId: string | undefined, userId: string | undefined, workspaceId: string): Promise<ReservedSeatAssignment> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/licensemanagement/RemoveSeatReservedAssignment?";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (licenseAssignmentId === null)
            throw new Error("The parameter 'licenseAssignmentId' cannot be null.");
        else if (licenseAssignmentId !== undefined)
            url_ += "licenseAssignmentId=" + encodeURIComponent("" + licenseAssignmentId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveSeatReservedAssignment(_response));
        });
    }

    protected processRemoveSeatReservedAssignment(response: Response): Promise<ReservedSeatAssignment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReservedSeatAssignment;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReservedSeatAssignment>(null as any);
    }

    /**
     * @return OK
     */
    getSeatUsage(workspaceId: string): Promise<SeatUsageGroup[]> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/licensemanagement/GetSeatUsage";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSeatUsage(_response));
        });
    }

    protected processGetSeatUsage(response: Response): Promise<SeatUsageGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SeatUsageGroup[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeatUsageGroup[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    releaseLicense(workspaceId: string, body: ReleaseLicenseRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/licensemanagement/ReleaseLicense";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReleaseLicense(_response));
        });
    }

    protected processReleaseLicense(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getWorkspaceMembers(workspaceId: string): Promise<WorkspaceMemberInfo[]> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/licensemanagement/GetWorkspaceMembers";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWorkspaceMembers(_response));
        });
    }

    protected processGetWorkspaceMembers(response: Response): Promise<WorkspaceMemberInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkspaceMemberInfo[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkspaceMemberInfo[]>(null as any);
    }

    /**
     * @return OK
     */
    getArchivedLicenses(workspaceId: string): Promise<LicenseInfo[]> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/licenses/GetArchivedLicenses";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetArchivedLicenses(_response));
        });
    }

    protected processGetArchivedLicenses(response: Response): Promise<LicenseInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseInfo[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseInfo[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setupStart(workspaceId: string, body: SetupStartRequest | undefined): Promise<SetupIntentInfo> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/payments/SetupStart";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetupStart(_response));
        });
    }

    protected processSetupStart(response: Response): Promise<SetupIntentInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetupIntentInfo;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetupIntentInfo>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPaymentConfg(workspaceId: string, body: SetupStartRequest | undefined): Promise<SetupIntentInfo> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/payments/GetPaymentConfg";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaymentConfg(_response));
        });
    }

    protected processGetPaymentConfg(response: Response): Promise<SetupIntentInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetupIntentInfo;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetupIntentInfo>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    savePaymentMethod(workspaceId: string, body: UpdatePaymentInfoRequest | undefined): Promise<SavePaymentMethodResponse> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/payments/SavePaymentMethod";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSavePaymentMethod(_response));
        });
    }

    protected processSavePaymentMethod(response: Response): Promise<SavePaymentMethodResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SavePaymentMethodResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SavePaymentMethodResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveAddress(workspaceId: string, body: SaveAddressRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/payments/SaveAddress";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveAddress(_response));
        });
    }

    protected processSaveAddress(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    payQuote(workspaceId: string, body: PayQuoteRequest | undefined): Promise<PayQuoteResult> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/payments/PayQuote";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPayQuote(_response));
        });
    }

    protected processPayQuote(response: Response): Promise<PayQuoteResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayQuoteResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PayQuoteResult>(null as any);
    }

    /**
     * @return OK
     */
    getAvailableProducts(workspaceId: string): Promise<SubscriptionProduct[]> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/ProductCatalog/GetAvailableProducts";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAvailableProducts(_response));
        });
    }

    protected processGetAvailableProducts(response: Response): Promise<SubscriptionProduct[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionProduct[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionProduct[]>(null as any);
    }

    /**
     * @return OK
     */
    productCatalog(workspaceId: string): Promise<SubscriptionProduct[]> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/ProductCatalog";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProductCatalog(_response));
        });
    }

    protected processProductCatalog(response: Response): Promise<SubscriptionProduct[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionProduct[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionProduct[]>(null as any);
    }

    /**
     * @return OK
     */
    getQuote(workspaceId: string): Promise<Quote> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/quotes/GetQuote";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetQuote(_response));
        });
    }

    protected processGetQuote(response: Response): Promise<Quote> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Quote;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Quote>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cancelQuote(workspaceId: string, body: CancelQuoteRequest | undefined): Promise<QuoteOperationResult> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/quotes/CancelQuote";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCancelQuote(_response));
        });
    }

    protected processCancelQuote(response: Response): Promise<QuoteOperationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuoteOperationResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuoteOperationResult>(null as any);
    }

    /**
     * @param quoteId (optional) 
     * @param file (optional) 
     * @return OK
     */
    uploadQuotePurchaseOrder(workspaceId: string, quoteId: string | undefined, file: FileParameter | undefined): Promise<QuoteOperationResult> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/quotes/UploadQuotePurchaseOrder";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (quoteId === null || quoteId === undefined)
            throw new Error("The parameter 'quoteId' cannot be null.");
        else
            content_.append("quoteId", quoteId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadQuotePurchaseOrder(_response));
        });
    }

    protected processUploadQuotePurchaseOrder(response: Response): Promise<QuoteOperationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuoteOperationResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuoteOperationResult>(null as any);
    }

    /**
     * @return OK
     */
    createRenewalQuote(workspaceId: string): Promise<QuoteOperationResult> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/quotes/CreateRenewalQuote";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateRenewalQuote(_response));
        });
    }

    protected processCreateRenewalQuote(response: Response): Promise<QuoteOperationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuoteOperationResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuoteOperationResult>(null as any);
    }

    /**
     * @return OK
     */
    getQuoteGenerationSettings(workspaceId: string): Promise<QuoteGenerationSettings> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/quotes/GetQuoteGenerationSettings";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetQuoteGenerationSettings(_response));
        });
    }

    protected processGetQuoteGenerationSettings(response: Response): Promise<QuoteGenerationSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuoteGenerationSettings;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuoteGenerationSettings>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveQuoteGenerationSettings(workspaceId: string, body: QuoteGenerationSettingsRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/quotes/SaveQuoteGenerationSettings";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveQuoteGenerationSettings(_response));
        });
    }

    protected processSaveQuoteGenerationSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getCountriesWithStates(): Promise<CountryInfo[]> {
        let url_ = this.baseUrl + "/Regions/GetCountriesWithStates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCountriesWithStates(_response));
        });
    }

    protected processGetCountriesWithStates(response: Response): Promise<CountryInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CountryInfo[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryInfo[]>(null as any);
    }

    /**
     * @param countryCode (optional) 
     * @return OK
     */
    findRedirectionRule(countryCode: string | undefined): Promise<RedirectionRule> {
        let url_ = this.baseUrl + "/Regions/FindRedirectionRule?";
        if (countryCode === null)
            throw new Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFindRedirectionRule(_response));
        });
    }

    protected processFindRedirectionRule(response: Response): Promise<RedirectionRule> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RedirectionRule;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RedirectionRule>(null as any);
    }

    /**
     * @param locale (optional) 
     * @return OK
     */
    getIndustries(locale: string | undefined): Promise<IndustryInfo[]> {
        let url_ = this.baseUrl + "/Resources/GetIndustries?";
        if (locale === null)
            throw new Error("The parameter 'locale' cannot be null.");
        else if (locale !== undefined)
            url_ += "locale=" + encodeURIComponent("" + locale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIndustries(_response));
        });
    }

    protected processGetIndustries(response: Response): Promise<IndustryInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IndustryInfo[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IndustryInfo[]>(null as any);
    }

    /**
     * @return OK
     */
    getCancellationReasons(): Promise<CancellationReasonInfo[]> {
        let url_ = this.baseUrl + "/Resources/GetCancellationReasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCancellationReasons(_response));
        });
    }

    protected processGetCancellationReasons(response: Response): Promise<CancellationReasonInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CancellationReasonInfo[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CancellationReasonInfo[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    begin(workspaceId: string, body: BeginSubscriptionDraftRequest | undefined): Promise<SubscriptionDraft> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/SubscriptionDrafts/Begin";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBegin(_response));
        });
    }

    protected processBegin(response: Response): Promise<SubscriptionDraft> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionDraft;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionDraft>(null as any);
    }

    /**
     * @return OK
     */
    subscriptionDrafts(draftId: string, workspaceId: string): Promise<SubscriptionDraft> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/SubscriptionDrafts/{draftId}";
        if (draftId === undefined || draftId === null)
            throw new Error("The parameter 'draftId' must be defined.");
        url_ = url_.replace("{draftId}", encodeURIComponent("" + draftId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubscriptionDrafts(_response));
        });
    }

    protected processSubscriptionDrafts(response: Response): Promise<SubscriptionDraft> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionDraft;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionDraft>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    selection(draftId: string, workspaceId: string, body: UpdateDraftSelectionRequest | undefined): Promise<SubscriptionDraft> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/SubscriptionDrafts/{draftId}/Selection";
        if (draftId === undefined || draftId === null)
            throw new Error("The parameter 'draftId' must be defined.");
        url_ = url_.replace("{draftId}", encodeURIComponent("" + draftId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSelection(_response));
        });
    }

    protected processSelection(response: Response): Promise<SubscriptionDraft> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionDraft;
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionDraft>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    paymentSettings(draftId: string, workspaceId: string, body: UpdateDraftPaymentSettingsRequest | undefined): Promise<SubscriptionDraft> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/SubscriptionDrafts/{draftId}/PaymentSettings";
        if (draftId === undefined || draftId === null)
            throw new Error("The parameter 'draftId' must be defined.");
        url_ = url_.replace("{draftId}", encodeURIComponent("" + draftId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPaymentSettings(_response));
        });
    }

    protected processPaymentSettings(response: Response): Promise<SubscriptionDraft> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionDraft;
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionDraft>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    coupon(draftId: string, workspaceId: string, body: ApplyDraftStripePromoCodeRequest | undefined): Promise<SubscriptionDraft> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/SubscriptionDrafts/{draftId}/Coupon";
        if (draftId === undefined || draftId === null)
            throw new Error("The parameter 'draftId' must be defined.");
        url_ = url_.replace("{draftId}", encodeURIComponent("" + draftId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCoupon(_response));
        });
    }

    protected processCoupon(response: Response): Promise<SubscriptionDraft> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionDraft;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionDraft>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    taxNumber(draftId: string, workspaceId: string, body: UpdateDraftTaxNumberRequest | undefined): Promise<SubscriptionDraft> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/SubscriptionDrafts/{draftId}/TaxNumber";
        if (draftId === undefined || draftId === null)
            throw new Error("The parameter 'draftId' must be defined.");
        url_ = url_.replace("{draftId}", encodeURIComponent("" + draftId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTaxNumber(_response));
        });
    }

    protected processTaxNumber(response: Response): Promise<SubscriptionDraft> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionDraft;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionDraft>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    applyWithholdingTaxPreference(draftId: string, workspaceId: string, body: UpdateDraftApplyWithholdingTaxPreferenceRequest | undefined): Promise<SubscriptionDraft> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/SubscriptionDrafts/{draftId}/ApplyWithholdingTaxPreference";
        if (draftId === undefined || draftId === null)
            throw new Error("The parameter 'draftId' must be defined.");
        url_ = url_.replace("{draftId}", encodeURIComponent("" + draftId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApplyWithholdingTaxPreference(_response));
        });
    }

    protected processApplyWithholdingTaxPreference(response: Response): Promise<SubscriptionDraft> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionDraft;
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionDraft>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addresses(draftId: string, workspaceId: string, body: UpdateDraftAddressesRequest | undefined): Promise<SubscriptionDraft> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/SubscriptionDrafts/{draftId}/Addresses";
        if (draftId === undefined || draftId === null)
            throw new Error("The parameter 'draftId' must be defined.");
        url_ = url_.replace("{draftId}", encodeURIComponent("" + draftId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddresses(_response));
        });
    }

    protected processAddresses(response: Response): Promise<SubscriptionDraft> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionDraft;
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionDraft>(null as any);
    }

    /**
     * @return No Content
     */
    abandon(draftId: string, workspaceId: string): Promise<void> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/SubscriptionDrafts/{draftId}/Abandon";
        if (draftId === undefined || draftId === null)
            throw new Error("The parameter 'draftId' must be defined.");
        url_ = url_.replace("{draftId}", encodeURIComponent("" + draftId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAbandon(_response));
        });
    }

    protected processAbandon(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cost(draftId: string, workspaceId: string, body: CalculateDraftCostRequest | undefined): Promise<SubscriptionCostResponse> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/SubscriptionDrafts/{draftId}/Cost";
        if (draftId === undefined || draftId === null)
            throw new Error("The parameter 'draftId' must be defined.");
        url_ = url_.replace("{draftId}", encodeURIComponent("" + draftId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCost(_response));
        });
    }

    protected processCost(response: Response): Promise<SubscriptionCostResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionCostResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionCostResponse>(null as any);
    }

    /**
     * @return OK
     */
    getSubscriptionInfo(workspaceId: string): Promise<BillingInfo> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/subscriptions/GetSubscriptionInfo";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSubscriptionInfo(_response));
        });
    }

    protected processGetSubscriptionInfo(response: Response): Promise<BillingInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BillingInfo;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BillingInfo>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(workspaceId: string, body: CreateSubscriptionRequest | undefined): Promise<CreateSubscriptionResponse> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/subscriptions/Create";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CreateSubscriptionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateSubscriptionResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateSubscriptionResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    subscribeToProduct(workspaceId: string, body: SubscribeToProductRequest | undefined): Promise<AddProductResponse> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/subscriptions/SubscribeToProduct";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubscribeToProduct(_response));
        });
    }

    protected processSubscribeToProduct(response: Response): Promise<AddProductResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddProductResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddProductResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    calculateSubscriptionCost(workspaceId: string, body: SubscriptionCostRequest | undefined): Promise<SubscriptionCostResponse> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/subscriptions/CalculateSubscriptionCost";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCalculateSubscriptionCost(_response));
        });
    }

    protected processCalculateSubscriptionCost(response: Response): Promise<SubscriptionCostResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionCostResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionCostResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    calculateSubscriptionUpdateCost(workspaceId: string, body: SubscriptionChangeCostRequest | undefined): Promise<SubscriptionChangeInvoiceResponse> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/subscriptions/CalculateSubscriptionUpdateCost";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCalculateSubscriptionUpdateCost(_response));
        });
    }

    protected processCalculateSubscriptionUpdateCost(response: Response): Promise<SubscriptionChangeInvoiceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionChangeInvoiceResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionChangeInvoiceResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cancelSubscription(workspaceId: string, body: CancelSubscriptionRequestModel | undefined): Promise<CancelSubscriptionResponse> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/subscriptions/CancelSubscription";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCancelSubscription(_response));
        });
    }

    protected processCancelSubscription(response: Response): Promise<CancelSubscriptionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CancelSubscriptionResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CancelSubscriptionResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSubscriptionProductPrices(workspaceId: string, body: SubscriptionProductPricesRequest | undefined): Promise<SubscriptionProductPrice[]> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/subscriptions/GetSubscriptionProductPrices";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSubscriptionProductPrices(_response));
        });
    }

    protected processGetSubscriptionProductPrices(response: Response): Promise<SubscriptionProductPrice[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionProductPrice[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionProductPrice[]>(null as any);
    }

    /**
     * @param couponCode (optional) 
     * @param countryCode (optional) 
     * @return OK
     */
    validateCoupon(workspaceId: string, couponCode: string | undefined, countryCode: string | undefined): Promise<SubscriptionCouponResponse> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/subscriptions/ValidateCoupon?";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (couponCode === null)
            throw new Error("The parameter 'couponCode' cannot be null.");
        else if (couponCode !== undefined)
            url_ += "couponCode=" + encodeURIComponent("" + couponCode) + "&";
        if (countryCode === null)
            throw new Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidateCoupon(_response));
        });
    }

    protected processValidateCoupon(response: Response): Promise<SubscriptionCouponResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionCouponResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionCouponResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validateSubscription(workspaceId: string, body: ValidateSubscriptionRequest | undefined): Promise<ValidateSubscriptionResult> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/subscriptions/ValidateSubscription";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidateSubscription(_response));
        });
    }

    protected processValidateSubscription(response: Response): Promise<ValidateSubscriptionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidateSubscriptionResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidateSubscriptionResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateProductQuantity(workspaceId: string, body: UpdateProductQuantityRequest | undefined): Promise<UpdateProductQuantityResponse> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/subscriptions/UpdateProductQuantity";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateProductQuantity(_response));
        });
    }

    protected processUpdateProductQuantity(response: Response): Promise<UpdateProductQuantityResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateProductQuantityResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateProductQuantityResponse>(null as any);
    }
}

export interface AddProductResponse {
    subscriptionId: string | undefined;
    status: SubscriptionStates;
    complianceStatus: ComplianceStatuses;
    purchaseOrderStatus: PurchaseOrderStatus;
    paymentConfirmation: SubscriptionPaymentConfirmationInfo;
}

export interface AddressInfo {
    street: string | undefined;
    city: string | undefined;
    zipCode: string | undefined;
    country: CountryInfo;
    stateCode: string | undefined;
}

export interface AnonymousQuoteInfo {
    quoteId: string | undefined;
    hrId: string | undefined;
    workspaceName: string | undefined;
    totalPrice: number;
    currencyCode: string | undefined;
    expirationDate: string;
    items: AnonymousQuoteItem[] | undefined;
    canUploadPurchaseOrder: boolean;
    unavailableReason: string | undefined;
}

export interface AnonymousQuoteItem {
    name: string | undefined;
    quantity: number;
    price: number;
    totalPrice: number;
}

export interface AnonymousUploadResult {
    success: boolean;
    message: string | undefined;
}

export interface ApplyDraftStripePromoCodeRequest {
    version: number;
    stripePromoCode: string | undefined;
}

export interface BeginSubscriptionDraftRequest {
    flow: SubscriptionDraftFlow;
    initialPaymentTerm: SubscriptionPaymentTerms;
    initialPaymentType: PaymentType;
    extensionProductIds: number[] | undefined;
    targetProductId: number | undefined;
    initialQuantity: number | undefined;
    resumeDraftId: string | undefined;
    billingAddress: AddressInfo;
    shippingAddress: AddressInfo;
}

export enum BillingFeatures {
    MonthlyPayments = "MonthlyPayments",
    AppsAndExtensions = "AppsAndExtensions",
    AnonymousFlow = "AnonymousFlow",
}

export interface BillingInfo {
    id: string | undefined;
    name: string | undefined;
    notificationContact: NotificationContact;
    paymentMethod: PaymentMethodInfo;
    paymentTerm: SubscriptionPaymentTerms;
    paymentType: PaymentType;
    endDate: string;
    status: SubscriptionStates;
    complianceStatus: ComplianceStatuses;
    purchaseOrderStatus: PurchaseOrderStatus;
    subscriptionType: SubscriptionTypes;
    purchaseOrderAvailable: boolean;
    currencyCode: string | undefined;
    minAuthors: number;
    maxAuthors: number;
    subscriptionButtonState: ButtonState;
    items: SubscriptionItem[] | undefined;
    permissions: BillingPermissions[] | undefined;
    customer: CustomerInfo;
    enabledFeatures: BillingFeatures[] | undefined;
    workspaceDeletionDate: string | undefined;
    nextPaymentAttempt: string | undefined;
    remainingRetryAttempts: number | undefined;
}

export enum BillingPermissions {
    CanChangeAuthors = "CanChangeAuthors",
    CanUpdatePaymentMethod = "CanUpdatePaymentMethod",
    CanUnsubscribe = "CanUnsubscribe",
    CanGenerateQuote = "CanGenerateQuote",
    CanViewNextPayment = "CanViewNextPayment",
    CanQuoteReset = "CanQuoteReset",
    CanCancelCurrentQuote = "CanCancelCurrentQuote",
    CanUseMonthlyPeriod = "CanUseMonthlyPeriod",
    CanReserveSeats = "CanReserveSeats",
    CanChangeSettings = "CanChangeSettings",
    CanViewArchivedLicenses = "CanViewArchivedLicenses",
    CanMigrate = "CanMigrate",
}

export enum ButtonState {
    Enabled = "Enabled",
    Disabled = "Disabled",
    Invisible = "Invisible",
}

export interface CalculateDraftCostRequest {
    addressInfo: AddressInfo;
}

export interface CancelQuoteRequest {
    quoteId: string | undefined;
}

export interface CancelSubscriptionRequestModel {
    reasonCode: string | undefined;
    comment: string | undefined;
}

export interface CancelSubscriptionResponse {
    subscriptionId: string | undefined;
    status: SubscriptionStates;
}

export interface CancellationReasonInfo {
    id: number;
    code: string | undefined;
    title: string | undefined;
}

export enum ComplianceStatuses {
    None = "None",
    UnderReview = "UnderReview",
    Approved = "Approved",
}

export interface CountryInfo {
    name: string | undefined;
    alpha2: string | undefined;
    entityId: string | undefined;
    states: StateInfo[] | undefined;
    currencyCode: string | undefined;
    taxBlockType: TaxBlockType;
}

export interface CreateReservedSeatAssignmentRequest {
    userId: string | undefined;
}

export interface CreateSubscriptionRequest {
    draftId: string | undefined;
    customerInfo: CustomerInfo;
    checkboxes: CustomerConfirmation[] | undefined;
    trackingId: string | undefined;
}

export interface CreateSubscriptionResponse {
    subscriptionId: string | undefined;
    status: SubscriptionStates;
    complianceStatus: ComplianceStatuses;
    purchaseOrderStatus: PurchaseOrderStatus;
    creationStatus: SubscriptionCreationStatus;
    paymentConfirmationInfo: SubscriptionPaymentConfirmationInfo;
    validationErrors: ValidationError[] | undefined;
}

export interface CustomerConfirmation {
    name: string | undefined;
    isChecked: boolean;
    text: string | undefined;
}

export interface CustomerInfo {
    billingAddress: AddressInfo;
    shippingAddress: AddressInfo;
    workspaceId: string | undefined;
    companyName: string | undefined;
    industry: string | undefined;
    customerTaxCode: string | undefined;
    email: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    fullName: string | undefined;
}

export interface DraftLineItem {
    productId: number;
    licenseId: string | undefined;
    quantity: number;
}

export interface EventLoggerRequest {
    guid: string | undefined;
    eventType: EventTypes;
    serviceInfo: string | undefined;
}

export enum EventTypes {
    KlarnaOffered = "KlarnaOffered",
    KlarnaTabClicked = "KlarnaTabClicked",
    ProceedToKlarna = "ProceedToKlarna",
    KlarnaOrderCompleted = "KlarnaOrderCompleted",
    SubscribeDialogDisplayed = "SubscribeDialogDisplayed",
    SubscribeDialogSubmitted = "SubscribeDialogSubmitted",
    UnsubscribeDialogDisplayed = "UnsubscribeDialogDisplayed",
    UnsubscribeDialogSubmitted = "UnsubscribeDialogSubmitted",
    EditPaymentMethodDialogDisplayed = "EditPaymentMethodDialogDisplayed",
    EditPaymentMethodDialogSubmitted = "EditPaymentMethodDialogSubmitted",
    NextPaymentPreviewDisplayed = "NextPaymentPreviewDisplayed",
    ManageAuthorsDialogDisplayed = "ManageAuthorsDialogDisplayed",
    ManageAuthorsDialogSubmitted = "ManageAuthorsDialogSubmitted",
    ConfirmAddAuthorsDialogDisplayed = "ConfirmAddAuthorsDialogDisplayed",
    ConfirmAddAuthorsDialogSubmitted = "ConfirmAddAuthorsDialogSubmitted",
    ConfirmRemoveAuthorsDialogDisplayed = "ConfirmRemoveAuthorsDialogDisplayed",
    ConfirmRemoveAuthorsDialogSubmitted = "ConfirmRemoveAuthorsDialogSubmitted",
    ReleaseUserDialogDisplayed = "ReleaseUserDialogDisplayed",
    ReleaseUserDialogSubmitted = "ReleaseUserDialogSubmitted",
    InvoiceListDisplayed = "InvoiceListDisplayed",
    AddToSubscriptionDialogDisplayed = "AddToSubscriptionDialogDisplayed",
    AddToSubscriptionDialogSubmitted = "AddToSubscriptionDialogSubmitted",
    ManageAddressDialogDisplayed = "ManageAddressDialogDisplayed",
    ManageAddressDialogSubmitted = "ManageAddressDialogSubmitted",
    BenefitsViewDisplayed = "BenefitsViewDisplayed",
    LicensesViewDisplayed = "LicensesViewDisplayed",
    WorkspaceViewDisplayed = "WorkspaceViewDisplayed",
    UsersViewDisplayed = "UsersViewDisplayed",
    CardViewDisplayed = "CardViewDisplayed",
    TermsViewDisplayed = "TermsViewDisplayed",
    MigrationStarted = "MigrationStarted",
    MigrationCompleted = "MigrationCompleted",
    MigrationFailed = "MigrationFailed",
    ReserveSeatDialogDisplayed = "ReserveSeatDialogDisplayed",
    ReserveSeatDialogSubmitted = "ReserveSeatDialogSubmitted",
    RevokeRoamedSeatDialogDisplayed = "RevokeRoamedSeatDialogDisplayed",
    RevokeRoamedSeatDialogSubmitted = "RevokeRoamedSeatDialogSubmitted",
}

export interface ExtensionTile {
    name: string | undefined;
    description: string | undefined;
    bannerUrl: string | undefined;
    iconUrl: string | undefined;
    priceInfo: SubscriptionItemPricingInfo;
    actions: TileAction[] | undefined;
}

export interface GetInvoicesResponse {
    invoices: Invoice[] | undefined;
}

export interface IndustryInfo {
    id: number;
    title: string | undefined;
    name: string | undefined;
}

export enum IntentType {
    Payment = "Payment",
    Setup = "Setup",
}

export interface Invoice {
    id: string | undefined;
    number: string | undefined;
    amount: number;
    currencyCode: string | undefined;
    transactionDate: string | undefined;
    status: string | undefined;
    attachmentUrl: string | undefined;
}

export enum JurisdictionType {
    Country = "Country",
    State = "State",
    County = "County",
    City = "City",
    Special = "Special",
}

export interface LicenseInfo {
    id: string | undefined;
    productName: string | undefined;
    seats: number;
    licenseTypeName: string | undefined;
    licenseUsageName: string | undefined;
    geoScopeName: string | undefined;
    isTimeBased: boolean;
    serialNumber: string | undefined;
    activationCode: string | undefined;
}

export interface NotificationContact {
    id: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    profilePictureUrl: string | undefined;
}

export interface PayQuoteRequest {
    quoteId: string | undefined;
    checkboxes: CustomerConfirmation[] | undefined;
    trackingId: string | undefined;
    setupIntentId: string | undefined;
}

export interface PayQuoteResult {
    quote: Quote;
    subscriptionStatus: SubscriptionStates;
    complianceStatus: ComplianceStatuses;
    purchaseOrderStatus: PurchaseOrderStatus;
    subscriptionButtonState: ButtonState;
    permissions: BillingPermissions[] | undefined;
    confirmationSecret: string | undefined;
}

export interface PaymentMethodInfo {
    text: string | undefined;
    iconName: string | undefined;
}

export enum PaymentType {
    CreditCard = "CreditCard",
    PurchaseOrder = "PurchaseOrder",
    QuotePayment = "QuotePayment",
}

export interface ProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;

    [key: string]: any;
}

export interface ProductTaxItem {
    productId: string | undefined;
    taxAmount: number;
    taxableAmount: number;
    details: ProductTaxItemDetail[] | undefined;
}

export interface ProductTaxItemDetail {
    taxName: string | undefined;
    countryCode: string | undefined;
    region: string | undefined;
    jurisdictionName: string | undefined;
    jurisdictionType: JurisdictionType;
    taxAmount: number | undefined;
    taxableAmount: number | undefined;
    taxPercentage: number | undefined;
    taxIncluded: boolean;
    kind: TaxLineKind;
}

export enum PurchaseOrderStatus {
    WaitingForPurchaseOrder = "WaitingForPurchaseOrder",
    InReview = "InReview",
    Invalid = "Invalid",
    Expired = "Expired",
    Accepted = "Accepted",
}

export interface Quote {
    id: string | undefined;
    userId: string | undefined;
    hrId: string | undefined;
    startDate: string;
    expirationDate: string;
    status: QuoteStatus;
    quoteType: QuoteType;
    totalPrice: number;
    currencyCode: string | undefined;
    subscriptionId: string | undefined;
    readonly items: QuoteItem[] | undefined;
}

export interface QuoteGenerationSettings {
    periodDays: number;
    readonly minValue: number;
    readonly maxValue: number;
}

export interface QuoteGenerationSettingsRequest {
    periodDays: number;
}

export interface QuoteItem {
    name: string | undefined;
    pictureName: string | undefined;
    unitLabel: string | undefined;
    productId: number;
    productPriceId: number | undefined;
    licenseId: string | undefined;
    quantity: number;
    price: number;
    tax: number;
    totalPrice: number;
    isPlatformFee: boolean;
    productTaxItem: ProductTaxItem;
    stripePriceId: string | undefined;
}

export interface QuoteOperationResult {
    quote: Quote;
    subscriptionStatus: SubscriptionStates;
    complianceStatus: ComplianceStatuses;
    purchaseOrderStatus: PurchaseOrderStatus;
    subscriptionButtonState: ButtonState;
    permissions: BillingPermissions[] | undefined;
}

export enum QuoteStatus {
    Open = "Open",
    Closed = "Closed",
    Invalid = "Invalid",
    Expired = "Expired",
    Cancelled = "Cancelled",
    PurchaseOrderUploaded = "PurchaseOrderUploaded",
}

export enum QuoteType {
    Draft = "Draft",
    Regular = "Regular",
    Renew = "Renew",
    P2T = "P2T",
    SubscriptionCreate = "SubscriptionCreate",
    SubscriptionUpdate = "SubscriptionUpdate",
    SubscriptionCycle = "SubscriptionCycle",
}

export interface RedirectionResource {
    headerText: string | undefined;
    messageText: string | undefined;
    ctaText: string | undefined;
}

export interface RedirectionRule {
    countryCode: string | undefined;
    regionId: number | undefined;
    hubUrl: string | undefined;
    description: string | undefined;
    isActive: boolean;
    resource: RedirectionResource;
}

export interface ReleaseLicenseRequest {
    leaseCertificateId: string | undefined;
}

export interface ReservedSeatAssignment {
    licenseId: string | undefined;
    licenseAssignmentId: string | undefined;
    userId: string | undefined;
    fullName: string | undefined;
    email: string | undefined;
    profilePicUrl: string | undefined;
}

export interface SaveAddressRequest {
    billingAddress: AddressInfo;
    shippingAddress: AddressInfo;
}

export interface SavePaymentMethodResponse {
    paymentMethod: PaymentMethodInfo;
}

export interface SeatUsageGroup {
    groupName: string | undefined;
    seatsTotal: number;
    usageItems: SeatUsageItem[] | undefined;
}

export interface SeatUsageItem {
    userId: string | undefined;
    fullName: string | undefined;
    email: string | undefined;
    profilePicUrl: string | undefined;
    licenseId: string | undefined;
    status: SeatUsageStatus;
    licenseAssignmentId: string | undefined;
    leaseCertificateId: string | undefined;
}

export enum SeatUsageStatus {
    ReservedSeat = "ReservedSeat",
    TakenOnline = "TakenOnline",
}

export interface SetupIntentInfo {
    customerExternalId: string | undefined;
    entityId: string | undefined;
    publishableKey: string | undefined;
    clientSecret: string | undefined;
    setupIntentId: string | undefined;
}

export interface SetupStartRequest {
    countryCode: string | undefined;
}

export interface StateInfo {
    name: string | undefined;
    code: string | undefined;
}

export interface SubscribeToProductRequest {
    transactionId: number | undefined;
    transactionGuid: string | undefined;
    draftId: string | undefined;
    trackingId: string | undefined;
    subscriptionId: string | undefined;
    setupIntentId: string | undefined;
    item: SubscriptionItem;
    checkboxes: CustomerConfirmation[] | undefined;
}

export interface SubscriptionChangeCostRequest {
    items: SubscriptionItem[] | undefined;
}

export interface SubscriptionChangeInvoiceResponse {
    subTotal: number;
    total: number;
    currency: string | undefined;
    items: SubscriptionInvoiceItem[] | undefined;
}

export interface SubscriptionCostBreakdownItem {
    productId: string | undefined;
    name: string | undefined;
    currency: string | undefined;
    quantity: number;
    price: number;
    total: number;
    tax: number;
    discount: number;
    taxDetails: ProductTaxItemDetail[] | undefined;
}

export interface SubscriptionCostRequest {
    address: AddressInfo;
    subscriptionType: SubscriptionTypes;
    paymentTerm: SubscriptionPaymentTerms;
    couponCode: string | undefined;
    items: SubscriptionItem[] | undefined;
    customerTaxNumber: string | undefined;
    applyWithholdingTax: boolean;
}

export interface SubscriptionCostResponse {
    items: SubscriptionCostBreakdownItem[] | undefined;
    totalExcludingTax: number;
    total: number;
    currency: string | undefined;
    isTaxCalculated: boolean;
    isTaxWithholdingAvailable: boolean;
    isCostCalculated: boolean;
    discounts: SubscriptionDiscountBreakdown[] | undefined;
    validationErrors: ValidationError[] | undefined;
    taxLines: SubscriptionTaxLine[] | undefined;
}

export interface SubscriptionCouponResponse {
    valid: boolean;
    code: string | undefined;
}

export enum SubscriptionCreationStatus {
    Succeeded = "Succeeded",
    Failed = "Failed",
    ActionRequired = "ActionRequired",
}

export interface SubscriptionDiscountBreakdown {
    code: string | undefined;
    couponName: string | undefined;
    total: number;
}

export interface SubscriptionDraft {
    draftId: string | undefined;
    workspaceId: string | undefined;
    cartId: string | undefined;
    flow: SubscriptionDraftFlow;
    status: SubscriptionDraftStatus;
    currencyCode: string | undefined;
    stripePromoCode: string | undefined;
    billingAddress: AddressInfo;
    shippingAddress: AddressInfo;
    paymentTerm: SubscriptionPaymentTerms;
    paymentType: PaymentType;
    lineItems: DraftLineItem[] | undefined;
    quoteId: string | undefined;
    createdAtUtc: string;
    lastModifiedAtUtc: string;
    version: number;
    taxNumber: string | undefined;
    applyWithholdingTax: boolean;
}

export enum SubscriptionDraftFlow {
    Subscribe = "Subscribe",
    AddSeat = "AddSeat",
    QuotePayment = "QuotePayment",
    SubscribeWithExtension = "SubscribeWithExtension",
}

export enum SubscriptionDraftStatus {
    InProgress = "InProgress",
    Completed = "Completed",
    Abandoned = "Abandoned",
    Failed = "Failed",
}

export interface SubscriptionInvoiceItem {
    id: string | undefined;
    productId: string | undefined;
    bundleId: string | undefined;
    name: string | undefined;
    currency: string | undefined;
    quantity: number;
    price: number;
    total: number;
    tax: number;
    discount: number;
    unitLabel: string | undefined;
    taxDetails: ProductTaxItemDetail[] | undefined;
    extendedInfo: SubscriptionInvoiceItemExtendedInfo;
}

export interface SubscriptionInvoiceItemExtendedInfo {
    externalProductId: string | undefined;
    productPriceId: number;
    priceBlockId: number;
    revisionId: number;
    dssProductName: string | undefined;
}

export interface SubscriptionItem {
    name: string | undefined;
    quantityInfo: SubscriptonItemQuantityInfo;
    pricingInfo: SubscriptionItemPricingInfo;
    productId: number;
    licenseId: string | undefined;
    iconUrl: string | undefined;
    isEval: boolean;
    isPlatformFee: boolean;
}

export interface SubscriptionItemArgs {
    productId: number;
    quantity: number;
}

export interface SubscriptionItemPricingInfo {
    price: number;
    currency: string | undefined;
    term: SubscriptionPaymentTerms;
    readonly termLabel: string | undefined;
}

export interface SubscriptionPaymentConfirmationInfo {
    type: IntentType;
    clientSecret: string | undefined;
}

export enum SubscriptionPaymentTerms {
    Yearly = "Yearly",
    Monthly = "Monthly",
    Weekly = "Weekly",
    Daily = "Daily",
}

export interface SubscriptionProduct {
    productId: number;
    externalId: string | undefined;
    name: string | undefined;
    description: string | undefined;
    iconName: string | undefined;
    bannerName: string | undefined;
    productPageUrl: string | undefined;
    unitLabel: string | undefined;
    isEditable: boolean;
}

export interface SubscriptionProductPrice {
    productId: number;
    isDefault: boolean;
    currencyCode: string | undefined;
    price: number;
    priceId: string | undefined;
}

export interface SubscriptionProductPricesRequest {
    countryCode: string | undefined;
    paymentTerm: SubscriptionPaymentTerms;
}

export enum SubscriptionStates {
    Incomplete = "Incomplete",
    Expired = "Expired",
    Trialing = "Trialing",
    Active = "Active",
    PastDue = "PastDue",
    Canceled = "Canceled",
    Unpaid = "Unpaid",
    Paused = "Paused",
    Inactive = "Inactive",
}

export interface SubscriptionTaxLine {
    label: string | undefined;
    amount: number;
}

export enum SubscriptionTypes {
    Eval = "Eval",
    Migrated = "Migrated",
}

export interface SubscriptonItemQuantityInfo {
    quantity: number;
    unitLabel: string | undefined;
    periodEnd: string;
    nextPeriodQuantity: number | undefined;
    readonly isQuantityChanged: boolean;
}

export enum TaxBlockType {
    None = "None",
    Vat = "Vat",
    Gst = "Gst",
    TaxExempt = "TaxExempt",
}

export enum TaxLineKind {
    Standard = "Standard",
    Tds = "Tds",
}

export interface TileAction {
    name: string | undefined;
    url: string | undefined;
    type: TileActionTypes;
    disabled: boolean | undefined;
    hint: string | undefined;
}

export enum TileActionTypes {
    Primary = "Primary",
    Secondary = "Secondary",
}

export interface UpdateDraftAddressesRequest {
    version: number;
    billingAddress: AddressInfo;
    shippingAddress: AddressInfo;
}

export interface UpdateDraftApplyWithholdingTaxPreferenceRequest {
    version: number;
    applyWithholdingTax: boolean;
}

export interface UpdateDraftPaymentSettingsRequest {
    version: number;
    paymentTerm: SubscriptionPaymentTerms;
    paymentType: PaymentType;
}

export interface UpdateDraftSelectionRequest {
    version: number;
    lineItems: DraftLineItem[] | undefined;
}

export interface UpdateDraftTaxNumberRequest {
    version: number;
    taxNumber: string | undefined;
}

export interface UpdatePaymentInfoRequest {
    subscriptionId: string | undefined;
    setupIntentId: string | undefined;
    customerInfo: CustomerInfo;
    checkboxes: CustomerConfirmation[] | undefined;
}

export interface UpdateProductQuantityRequest {
    draftId: string | undefined;
    trackingId: string | undefined;
    subscriptionId: string | undefined;
    paymentType: PaymentType;
    productId: number;
    quantity: number;
    setupIntentId: string | undefined;
    transactionId: number | undefined;
    transactionGuid: string | undefined;
    checkboxes: CustomerConfirmation[] | undefined;
}

export interface UpdateProductQuantityResponse {
    subscriptionId: string | undefined;
    status: SubscriptionStates;
    complianceStatus: ComplianceStatuses;
    purchaseOrderStatus: PurchaseOrderStatus;
    paymentConfirmation: SubscriptionPaymentConfirmationInfo;
}

export interface ValidateSubscriptionRequest {
    subscriptionItems: SubscriptionItemArgs[] | undefined;
}

export interface ValidateSubscriptionResult {
    alertText: string | undefined;
}

export interface ValidationError {
    type: ValidationErrorType;
    message: string | undefined;
}

export enum ValidationErrorType {
    None = "None",
    CustomerTaxCode = "CustomerTaxCode",
    CustomerTax = "CustomerTax",
}

export interface WorkspaceMemberInfo {
    userId: string | undefined;
    userName: string | undefined;
    email: string | undefined;
    profilePictureUrl: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

const urlReplacer = "<BASE_URL>";